module.exports = __webpack_public_path__ + "img/pg3-article-title2-inner.df987dc0.png";